import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

export const GQL_GET_MY_SCORM_TRACKING = typedGql('query', { scalars })({
  getMyScormTracking: [
    // `moduleId` cible le module du parcours dont on reprend la progression
    // (#139). Absent, l'API vise le premier module.
    { sessionId: $('sessionId', 'ID!'), moduleId: $('moduleId', 'ID') },
    {
      id: true,
      completionStatus: true,
      successStatus: true,
      scoreRaw: true,
      scoreMin: true,
      scoreMax: true,
      scoreScaled: true,
      totalTime: true,
      sessionTime: true,
      suspendData: true,
      location: true,
      completedAt: true,
      userId: true,
      sessionId: true,
    },
  ],
})

export const GQL_UPSERT_SCORM_TRACKING = typedGql('mutation')({
  upsertScormTracking: [
    {
      input: $('input', 'UpsertScormTrackingInput!'),
    },
    {
      id: true,
      completionStatus: true,
      successStatus: true,
      scoreRaw: true,
      scoreMin: true,
      scoreMax: true,
      scoreScaled: true,
      totalTime: true,
      suspendData: true,
      location: true,
      completedAt: true,
    },
  ],
})

// Agrégats du tableau de bord (#138). Requête distincte de la liste : elle porte
// sur tout le périmètre filtré, là où `getScormTrackings` ne rend qu'une page.
export const GQL_SCORM_TRACKING_STATS = typedGql('query', { scalars })({
  getScormTrackingStats: [
    {
      input: $('input', 'ScormTrackingStatsInput!'),
    },
    {
      total: true,
      completed: true,
      inProgress: true,
      notStarted: true,
      completionUnknown: true,
      neverOpened: true,
      notYetUnlocked: true,
      passed: true,
      failed: true,
      averageScorePercent: true,
      scoredCount: true,
      averageTimeSeconds: true,
      timedCount: true,
    },
  ],
})

export const GQL_SCORM_TRACKINGS = typedGql('query', { scalars })({
  getScormTrackings: [
    {
      input: $('input', 'FindManyScormTrackingWithFiltersInput!'),
    },
    {
      trackings: {
        id: true,
        completionStatus: true,
        successStatus: true,
        scoreRaw: true,
        scoreMin: true,
        scoreMax: true,
        scoreScaled: true,
        totalTime: true,
        completedAt: true,
        userId: true,
        userEmail: true,
        userFirstName: true,
        userLastName: true,
        sessionId: true,
        sessionName: true,
      },
      total: true,
    },
  ],
})
